<template>
  <div class="content-container">
    <LoadingSpinner v-if="loading_users" />
    <div class="col-md-12 px-0 mx-0 table-responsive" v-else>
      <Table class="mx-2 w-100" :key="3232323" :headers="headers" :cols="cols" :data="users" :checkbox="false"
        :notselect="true" :model="model" >
      </Table>
    </div>
  </div>
</template>
<script>
import { adminService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Table from "@/components/Common/Table.vue";
export default {
  props: {
    targetId: {
      type: String,
      default: 0,
    },
  },
  data() {
    return {
      loading_stats: true,
      loading_users: true,
      loading_history: true,
      detailsVisible: [false], // Ajustar según la cantidad de filas principales
      stats: [],
      users: [],
      userHistory: [],
      model: {
        imported: false,
        refreshlist: false,
        selectfirst: false,
        cantPerPage: 25,
        currentPage: 1,
      },
      cols: [
        [
          {
            value: "user",
          },
        ],
        [
          {
            value: "email",
          },
        ],
        [
          {
            value: "owarm_status_id",
            value_label: "owarm_status_id",
            type: "itemBadge",
            class: "badge badge-primary",
            colors: [
              {
                id: "2",
                label: "Active",
                bgColor: "green",
                textColor: "#FFFFFF",
              },
              {
                id: "4",
                label: "Stopped",
                bgColor: "red",
                textColor: "#FFFFFF",
              },
              {
                id: "1",
                label: "Warming-up",
                bgColor: "orange",
                textColor: "#FFFFFF",
              },
            ],
          },
        ],
        [
          {
            value: "provider",
            width: "20px",
            ImageWithIf: true,
            type: "image",
          },
        ],
        [
          {
            value: "start_on",
          },
        ],
        [
          {
            value: "emails_sent",
          },
        ],
      ],
      headers: [
        {
          label: "Teams",
          percentage: "0.1%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Email",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Status",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Provider",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Age",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
        {
          label: "Email sends",
          percentage: "10.5%",
          class: "overflowhide",
          permission: ["AgencyBilling", "isBookerManager", "isBdr"],
          id: 1,
        },
      ]
    };
  },
  created() {
    this.getSpamCheckUsersByTarget();
  },
  components: {
    LoadingSpinner,
    Table,
  },
  methods: {
    toggleDetails(index, owarm_id) {
      if (this.detailsVisible === index) {
        this.detailsVisible = null;
      } else {
        this.detailsVisible = index;
        this.loading_history = true;
        adminService.spamCheckHistoryByUser(owarm_id).then((res) => {
          this.userHistory = res;
          this.loading_history = false;
        });
      }
    },
    getSpamCheckStatsByTarget() {
      adminService.getSpamCheckStatsByTarget(this.targetId).then((res) => {
        this.stats = res;
        this.loading_stats = false;
      });
    },
    getSpamCheckUsersByTarget() {
      adminService.getSpamCheckUsersByTarget(this.targetId).then((res) => {
        console.log(res);
        this.users = res;
        this.users.forEach(user => {
          user.user = user.name + ' ' + user.lastname + ' (' + user.user_id + ')';
        });
        this.loading_users = false;
      });
    },
    getCLassStatus(owarm_status_id) {
      switch (owarm_status_id) {
        case "1":
          return "badge-warning";
        case "2":
          return "badge-success";
        case "4":
          return "badge-danger";
      }
    },
  },
};
</script>
<style scoped>
.content-container {
  padding: 20px;
}

.cards {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.card {
  background-color: #ffffff;
  border-radius: 28px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 30%;
  text-align: center;
  padding: 20px;
}

.card-history {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 20px;
  width: 100%;
}
.card-header {
  font-size: 1.2em;
  margin-bottom: 10px;
}

.card-body {
  font-size: 4em;
  font-weight: bold;
}
.details {
  background-color: #f9f9f9;
  padding: 10px;
}

.inbox-card {
  border-color: rgba(255, 166, 0, 0.507);
}

.spam-card {
  background-color: #ffebee;
}

.unreceived-card {
  background-color: #f3e5f5;
}

.table-container {
  overflow-x: auto;
}

.deliverability-tests {
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.deliverability-tests th,
.deliverability-tests td {
  padding: 15px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.deliverability-tests th {
  background-color: #f9f9f9;
}

.deliverability-tests img {
  height: 20px;
}

.deliverability-tests tbody tr:hover {
  background-color: #f1f1f1;
}
.scrollable-card {
  max-height: 250px;
  overflow-y: auto;
  overflow-x: hidden !important;
}
.badge-ligth-green {
  background-color: #edf7ec;
}
.badge-pink {
  background-color: #ffd0cf;
}
</style>